<div class="d-flex flex-column" *ngIf="kitchenDevice.softwareVersion && +kitchenDevice.softwareVersion > 1.13">
	<div class="d-flex mt-1">
		<div class="ms-auto flex-fill">
			<span class="p-float-label">
				<p-dropdown
					#copyColorProfileFromViewSelect
					[options]="venueService.licensesKitchenDevice.value"
					optionLabel="name"
					optionValue="key"
					name="copyColorProfileFromViewSelect"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(venueService.licensesKitchenDevice.value)"
					(onChange)="copyColorProfileFromView($event)"
				></p-dropdown>
				<label for="copyColorProfileFromView">Copy from View</label>
			</span>
		</div>
	</div>

	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#kitchenViewBackgroundColorSelect
							name="kitchenViewBackgroundColorSelect"
							type="text"
							[(ngModel)]="features.kitchenViewBackgroundColor"
							class="w-100"
						/>
						<label for="kitchenViewBackgroundColorSelect">Main background color</label>
					</span>
				</div>

				<p-colorPicker
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
					styleClass="ms-1 h-100"
					[(ngModel)]="features.kitchenViewBackgroundColor"
				></p-colorPicker>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill"></div>
			</div>
		</div>
	</div>
	<div class="d-flex">
		<div class="h4 ms-1 mt-2 mb-1">Order Header</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#kitchenHeaderBackgroundColorSelect
							name="kitchenHeaderBackgroundColorSelect"
							type="text"
							[(ngModel)]="features.kitchenHeaderBackgroundColor"
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
						/>
						<label for="kitchenHeaderBackgroundColorSelect">Order header normal color</label>
					</span>
				</div>

				<p-colorPicker
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
					styleClass="ms-1 h-100"
					[(ngModel)]="features.kitchenHeaderBackgroundColor"
				></p-colorPicker>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#kitchenUrgentHeaderBackgroundColorSelect
							name="kitchenUrgentHeaderBackgroundColorSelect"
							type="text"
							[(ngModel)]="features.kitchenUrgentHeaderBackgroundColor"
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
						/>
						<label for="kitchenUrgentHeaderBackgroundColorSelect">Order header urgent color</label>
					</span>
				</div>

				<p-colorPicker
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
					styleClass="ms-1 h-100"
					[(ngModel)]="features.kitchenUrgentHeaderBackgroundColor"
				></p-colorPicker>
			</div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#kitchenHeaderFontColorSelect
							name="kitchenHeaderFontColorSelect"
							type="text"
							[(ngModel)]="features.kitchenHeaderFontColor"
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
						/>
						<label for="kitchenHeaderFontColorSelect">Order header font color</label>
					</span>
				</div>

				<p-colorPicker
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
					styleClass="ms-1 h-100"
					[(ngModel)]="features.kitchenHeaderFontColor"
				></p-colorPicker>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<p-dropdown
							#kitchenHeaderFontSize
							[options]="fontSizeOptions"
							optionLabel="label"
							optionValue="value"
							name="kitchenHeaderFontSize"
							[(ngModel)]="features.kitchenHeaderFontSize"
							[style]="{ width: '100%' }"
							appendTo="body"
							[autoDisplayFirst]="false"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							(filterBy)="app.keys(fontSizeOptions)"
							(onChange)="changesToSaveChange.emit(true)"
						></p-dropdown>
						<label for="kitchenHeaderFontSize">Order header font size</label>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="d-flex">
		<div class="h4 ms-1 mt-2 mb-1">Items</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#kitchenOrderBackgroundColorSelect
							name="kitchenOrderBackgroundColorSelect"
							type="text"
							[(ngModel)]="features.kitchenOrderBackgroundColor"
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
						/>
						<label for="kitchenOrderBackgroundColorSelect">Order background color</label>
					</span>
				</div>

				<p-colorPicker
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
					styleClass="ms-1 h-100"
					[(ngModel)]="features.kitchenOrderBackgroundColor"
				></p-colorPicker>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#kitchenItemFontColorSelect
							name="kitchenItemFontColorSelect"
							type="text"
							[(ngModel)]="features.kitchenItemFontColor"
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
						/>
						<label for="kitchenItemFontColorSelect">Item font color</label>
					</span>
				</div>

				<p-colorPicker
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
					styleClass="ms-1 h-100"
					[(ngModel)]="features.kitchenItemFontColor"
				></p-colorPicker>
			</div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<input
							pInputText
							#kitchenModifierFontColorSelect
							name="kitchenModifierFontColorSelect"
							type="text"
							[(ngModel)]="features.kitchenModifierFontColor"
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
						/>
						<label for="kitchenModifierFontColorSelect">Modifier font color</label>
					</span>
				</div>

				<p-colorPicker
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
					styleClass="ms-1 h-100"
					[(ngModel)]="features.kitchenModifierFontColor"
				></p-colorPicker>
			</div>
		</div>
		<div class="p-col-12 p-md-6"></div>
	</div>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<p-dropdown
							#kitchenItemFontSizeSelect
							[options]="fontSizeOptions"
							optionLabel="label"
							optionValue="value"
							name="kitchenItemFontSizeSelect"
							[(ngModel)]="features.kitchenItemFontSize"
							[style]="{ width: '100%' }"
							appendTo="body"
							[autoDisplayFirst]="false"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							(filterBy)="app.keys(fontSizeOptions)"
							(onChange)="changesToSaveChange.emit(true)"
						></p-dropdown>
						<label for="kitchenItemFontSizeSelect">Item font size</label>
					</span>
				</div>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="flex-fill">
					<span class="p-float-label mt-4">
						<p-dropdown
							#kitchenModifierFontSizeSelect
							[options]="fontSizeOptions"
							optionLabel="label"
							optionValue="value"
							name="kitchenModifierFontSizeSelect"
							[(ngModel)]="features.kitchenModifierFontSize"
							[style]="{ width: '100%' }"
							appendTo="body"
							[autoDisplayFirst]="false"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							(filterBy)="app.keys(fontSizeOptions)"
							(onChange)="changesToSaveChange.emit(true)"
						></p-dropdown>
						<label for="kitchenModifierFontSizeSelect">Modifier font size</label>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="d-flex w-100" *ngIf="+kitchenDevice.softwareVersion <= 1.13">
	<div class="mx-auto display-12">FocusKitchen version 1.14 or higher is required to use this feature.</div>
</div>
